module.exports = __webpack_public_path__ + "img/mnms4.ca096fcd.png";